(function() {
  'use strict';
  angular
    .module('app.shared')
    .controller('CareersNewVariationController', CareersNewVariationController);

  CareersNewVariationController.$inject = [
    'APP_CONSTANTS',
    'toaster',
    '$scope',
    'selectedCareer',
    '$uibModalInstance',
    'DetailsService',
    'ProductService'
  ];

  function CareersNewVariationController(
    APP_CONSTANTS,
    toaster,
    $scope,
    selectedCareer,
    $uibModalInstance,
    DetailsService,
    ProductService
  ) {
    var vm = this;

    vm.loading = {};
    vm.availableLanguages = [];
    vm.productAssessments = [];
    vm.productLanguages = [];
    vm.newLanguageVariation = {};
    vm.dismissModal = dismissModal;
    vm.selectedCareer = selectedCareer;
    vm.careersLanguageVariationArray = [];
    vm.addNewVariation = addNewVariation;
    vm.productId = ProductService.getProductId();
    vm.fetchProductAssessments = fetchProductAssessments;

    vm.selectedCareerName = _.get(
      selectedCareer,
      'variations.en.name',
      APP_CONSTANTS.occupation
    );

    fetchProductAssessments();

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function fetchProductAssessments() {
      vm.loading.productInfo = true;

      DetailsService.fetchProductDetails(vm.productId)
        .then(function(result) {
          var matchedLanguage = [];

          vm.loading.productInfo = false;

          vm.productAssessments = _.get(
            result,
            'data.products[0].surveyVariations',
            []
          );

          vm.productAssessments.forEach(function(assessment) {
            vm.productLanguages.push(assessment.locale.language);
          });

          vm.productLanguages.forEach(function(language) {
            matchedLanguage = Object.keys(vm.selectedCareer.variations).filter(
              function(key) {
                return key === language.id;
              }
            );

            if (!matchedLanguage.length) vm.availableLanguages.push(language);
          });
        })
        .catch(function(error) {
          vm.loading.productInfo = false;
          toaster.pop('error', error.data.message || error.statusText);
        });
    }

    function addNewVariation() {
      $scope.$parent.vm.updateUnpublishedCareers(vm.selectedCareer.id);
      $scope.$parent.vm.updateNewVariationInCareer(
        vm.selectedCareer.id,
        vm.newLanguageVariation
      );

      dismissModal();
    }
  }
})();
